import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./customer_identifier.js";
import "./customer_identifier_input_method.js";
//#region src/customer_identifier_helper.ts
var customer_identifier_helper_exports = /* @__PURE__ */ __exportAll({
	enforcedAskAtBeginning: () => enforcedAskAtBeginning,
	inputMethods: () => inputMethods,
	name: () => name
});
function name(customerIdentifier) {
	switch (customerIdentifier) {
		case 1: return "Guest Name";
		case 2: return "Table Number";
		case 3: return "Bite Order Number";
		case 4: return "POS Order Number";
		case 5: return "Vehicle Description";
		case 6: return "Address";
		case 7: return "Phone Number";
		case 8: return "Email";
	}
}
function inputMethods(customerIdentifier) {
	switch (customerIdentifier) {
		case 1: return [2];
		case 2: return [3, 4];
		case 3:
		case 4: return [1];
		case 5: return [6];
		case 6: return [7];
		case 7: return [8];
		case 8: return [9];
	}
}
/**
* Delivery address always has to be at the beginning as it requires validation
*/
function enforcedAskAtBeginning(customerIdentifier) {
	switch (customerIdentifier) {
		case 6: return true;
		default: return false;
	}
}
//#endregion
export { customer_identifier_helper_exports, enforcedAskAtBeginning, inputMethods, name };

//# sourceMappingURL=customer_identifier_helper.js.map